import { RICH_TEXT_CONTENT_CLASS } from "@jugl-web/domain-resources/common/components/RichTextarea";
import { cx } from "@jugl-web/utils";
import format from "date-fns/format";
import DOMPurify from "dompurify";
import React from "react";
import { ReactComponent as BubbleIcon } from "./assets/bubble.svg";
import whatsappBg from "./assets/whatsapp-bg.webp";

export const TemplatePreview: React.FC<{
  header: string;
  bodyPlain: string;
  bodyHtml: string;
  footer: string;
}> = ({ header, bodyPlain, bodyHtml, footer }) => (
  <div
    className="w-[320px] shrink-0 rounded-lg bg-[#ece6de] bg-cover bg-center p-10"
    style={{ backgroundImage: `url(${whatsappBg})` }}
  >
    <div className="relative flex min-h-[80px] w-full flex-col rounded-lg bg-white px-3 py-2 font-secondary leading-3 wrap-break-word text-dark">
      {header && <span className="mb-2.5 font-bold">{header}</span>}
      {bodyPlain && (
        <div
          className={cx("mb-2.5", RICH_TEXT_CONTENT_CLASS)}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(bodyHtml, { ADD_ATTR: ["target"] }),
          }}
        />
      )}
      {footer && <span className="mb-2 text-sm text-[#828282]">{footer}</span>}
      <div className="mt-auto ml-auto">
        <span className="font-primary text-[13px] leading-[16px] text-[#9C9CA3]">
          {format(new Date(), "h:mm a")}
        </span>
      </div>
      <BubbleIcon className="absolute top-0 left-0 -translate-x-1/2" />
    </div>
  </div>
);
